
import React, { useEffect, useRef, Image } from "react"
import ReactDOM from "react-dom"
import "./layout.css"
export default function handleScroll(){
    
    section2_2();
    section2_3()
    
    
    
}


let section2_2 = () => {
  //get secont2_2

  let img1 = document.getElementsByClassName("section2_2")[0]
  // return;

  window.addEventListener("scroll", () => {
    if (img1 && img1.offsetTop - 500 < document.documentElement.scrollTop) {
      // do your stuff
      if (!img1.classList.contains("parralax-img"))
        img1.classList.add("parralax-img")
      //remove child elemenet of section 2
      let section_2_children = img1.childNodes
      let div = document.createElement("div")
      //div.classList.add("content")
      div.classList.add("parralax-text")
      Array.from(section_2_children).map((value, index) => {
        div.appendChild(value)
      })
      //remove section_2_children
      img1.innerHTML = ""
      //add class to img1
      img1.parentNode.insertBefore(div, img1.nextElementSibling)
    }
  })
}

let section2_3 = () => {

  let section231 = document.getElementsByClassName("section2_3_1")[0]
    
    if (!section231.classList.contains("parralax-img"))
    section231.classList.add("parralax-img")
    let section_2_children = section231.childNodes
    let div = document.createElement("div")
    //div.classList.add("content")
    div.classList.add("parralax-text2")
    Array.from(section_2_children).map((value, index) => {
      div.appendChild(value)
    })
    section231.innerHTML = ""
    section231.parentNode.insertBefore(div, section231.nextElementSibling)
  
}


